<template>
  <html-container
    :label="subIndex"
    :htmlContent="sub"
    :class="subquestionName"
  >
    <span slot="head">
      <label class="badge badge-default">{{questionType}}</label>
    </span>
    <p class="desp" slot="jianda" v-if="isJianda">{{ $t('question.EasyQuestionTips') }}</p>
    <div slot="body" style="margin-top: 16px;margin-left: 8px;">
      <sub-question-danxuan
        :is-active="isFocus"
        :sub-id="index"
        :right-answer="rightAnswer"
        :user-answer="user_answer"
        :options="options"
        @focus-subquestion="focusSubquestion"
        v-if="isDanxuan"></sub-question-danxuan>
      <sub-question-duoxuan
        :is-active="isFocus"
        :sub-id="index"
        :right-answer="rightAnswer"
        :user-answer="user_answer"
        @focus-subquestion="focusSubquestion"
        :options="options"
        v-if="isDuoxuan"></sub-question-duoxuan>
      <sub-question-jianda
        :is-active="isFocus"
        :sub-id="index"
        v-if="isJianda"></sub-question-jianda>
      <sub-question-tiankong
        :is-active="isFocus"
        @focus-subquestion="focusSubquestion"
        :sub-id="index"
        :right-answer="rightAnswer"
        :user-answer="user_answer"
        :result-unit="resultUnit"
        :is-focus="isFocus"
        v-if="isTiankong">
        </sub-question-tiankong>
    </div>
  </html-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import SubQuestionDanxuan from './sub/SubQuestionDanxuan'
import SubQuestionDuoxuan from './sub/SubQuestionDuoxuan'
import SubQuestionJianda from './sub/SubQuestionJianda'
import SubQuestionTiankong from './sub/SubQuestionTiankong'
import HtmlContainer from './sub/HtmlContainer'
import {
  QUESTION_TYPE_DANXUAN,
  QUESTION_TYPE_DUOXUAN,
  QUESTION_TYPE_TIANKONG,
  QUESTION_TYPE_JIANDA,
  QUESTION_TYPE_LANG_TEXT_MAP
} from '@ca/constants'
import { scrollPageByClass } from '@/utils'
import { $MathJaxHub } from '@/utils/question'

export default {
  name: 'SubQuestions',
  components: {
    'html-container': HtmlContainer,
    'sub-question-danxuan': SubQuestionDanxuan,
    'sub-question-duoxuan': SubQuestionDuoxuan,
    'sub-question-jianda': SubQuestionJianda,
    'sub-question-tiankong': SubQuestionTiankong
  },
  props: {
    subquestionLength: Number,
    options: {
      type: Array
    },
    result_unit: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      required: true,
      default: 1
    },
    sub: {
      type: String,
      required: true,
      default: ''
    },
    question_type: {
      type: Number,
      required: true
    },
    user_answer: {
      type: Object,
      required: true,
      default: () => {
        return {
          answer: 10,
          answered: 1,
          is_right: 1,
          question_id: 72,
          question_index: 1
        }
      }
    },
    right_answer: {
      default: '',
      getters: (value) => {
        if (value) {
          return value.toString()
        }
      }
    },
    visibleRightAnswer: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      types: {
        DANXUAN: QUESTION_TYPE_DANXUAN,
        DUOXUAN: QUESTION_TYPE_DUOXUAN,
        TIANKONG: QUESTION_TYPE_TIANKONG,
        JIANDA: QUESTION_TYPE_JIANDA
      },
      focusIndex: null
    }
  },
  computed: {
    ...mapGetters('answer', ['subquestionIndex']),
    resultUnit () {
      return this.result_unit
    },
    isFocus () {
      const isFocus = this.subquestionIndex === this.index
      this.$nextTick(() => {
        $MathJaxHub('single-question-page')
        if (isFocus) {
          scrollPageByClass(`subquestion-${this.index}`, {
            behavior: 'smooth',
            block: 'center'
          })
        }
      })
      return isFocus
    },
    subIndex () {
      return `${this.$t('question.Question')}${this.subquestionLength > 1 ? this.index + 1 : ''}`
    },
    subquestionName () {
      return `subquestion-${this.index} ${this.isFocus ? 'is-focus' : ''}`
    },
    questionType () {
      return this.$t(`question.${QUESTION_TYPE_LANG_TEXT_MAP[this.question_type]}`)
    },
    rightAnswer () {
      return this.visibleRightAnswer ? this.right_answer : null
    },
    isJianda () {
      return this.question_type === QUESTION_TYPE_JIANDA
    },
    isDanxuan () {
      return this.question_type === QUESTION_TYPE_DANXUAN
    },
    isDuoxuan () {
      return this.question_type === QUESTION_TYPE_DUOXUAN
    },
    isTiankong () {
      return this.question_type === QUESTION_TYPE_TIANKONG
    }
  },
  methods: {
    ...mapActions('answer', ['updateSubquestionIndex']),
    focusSubquestion (index) {
      if (index >= 0 && index < this.subquestionLength) {
        this.updateSubquestionIndex(index)
      }
    }
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';

.badge {
  display: inline-block;
  border-radius:2px;
  vertical-align: middle;
  &-default {
    background:rgba(26, 61, 94, 0.06);
    box-shadow:0px 2px 14px 0px rgba(79,117,162,0.07);
    color:$secondary;
  }
  &.is-plain {
    color: $info;
  }
  &.is-plain,
  &-default {
    font-size:12px;
    font-family:SFProDisplay-Regular;
    font-weight:400;
    line-height:12px;
    padding: 6px 8px;
  }
}
.badge{
  margin-left: 8px;
}
.desp{
  font-size:14px;
font-family:SFProDisplay;
font-weight:400;
color:rgba(163,177,191,1);
margin-bottom: 10px;
padding-left: 8px;
}
</style>
